import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link,useParams,useLocation,useNavigate  } from "react-router-dom";
import { APIURL,TZ } from "../../../Global";
import Pagination from "react-js-pagination";
import "../regdhospital.css"
import "../pagination.css";
import "../service.css"
import "../labsp.css"
import LoadingOverlay from 'react-loading-overlay';
import { ToggleButton } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';


function RegisteredHospitals() {
  const { state } = useLocation()
  const [selected, setSelected] = useState(state&&state.approve?"approved":"pending")
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sort,setSort]=useState("");
  const [nameSearch,setNameSearch]=useState("")
  const [locSearch,setLocSearch]=useState("")
  const [idSearch,setIdSearch]=useState("")
  const [typeSearch,setTypeSearch]=useState("")
  const [perPage,] = useState(10);const [approve, setApproved] = useState(false)
const navigate = useNavigate();
  const {status} = useParams();
 console.log(status)
 
 
 console.log(state)

  useEffect(() => {
    if(selected!=="expired"){
     
    setLoading(true)
    const tokenString = sessionStorage.getItem("usertoken");

    let v2 = tokenString.replace(
      /["]+/g,
      ""
    );
    axios.get(`${APIURL}/api/v1/staff/hospital-approve/?sort=${sort}&hospital_name=${nameSearch.trim()}&hospital_id=${idSearch.trim()}&health_care_type=${typeSearch.trim()}&location=${locSearch.trim()}&${selected==="approved" ? "status=approved" :selected==="rejected" ? "status=rejected": ""}` , {
      headers: { Authorization: "Token " + v2 },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          const data = res.data.hospitals
          setPending(data)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
    }
  }, [selected,sort,nameSearch,locSearch,typeSearch,idSearch])
  const getExpClinics = () => {
    setPending([])
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')
   
    axios.get(`${APIURL}/api/v1/staff/hospital-plans/?is_expired=true&${TZ}`, {
        headers: {

            "Authorization": 'Token ' + str
        }
    })
        .then(res => {

            if (res.data.status === "success") {
              
              if(res.data.details.length>0){
                let updatedList = [];
           updatedList = res.data.details.map((item)=>{
                  return {
                    "name": item.hospital_name,
                    "id": item.hospital_id,
                    "status": "expired"
                }
                })
               setPending(updatedList.length>0?updatedList:[])
              }
             
            }


        })
        .catch(err => {

        })



}

  const handleChangeRadio = (val) => {
    setApproved(val)
  }

  const handleSearchChange = (e) => {
    e.preventDefault();
    setCurrentPage(1)
    setSearchTerm(e.target.value)
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  


  // let data = pending.sort((a, b) => {
  //   if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  //   if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  //   return 0;
  // })
  //   .filter((value) => {
  //     if (searchTerm === '') {
  //       return value
  //     } else if (value.name.toLowerCase().includes(searchTerm.toLowerCase())) {
  //       return value
  //     }
  //   })


  const indexLast = currentPage * perPage;
  const indexFirst = indexLast - perPage;
  const current = pending.slice(indexFirst, indexLast);
  const total = pending.length;

  const pageNumbers = []
  for (let i = 0; i <= Math.ceil(total / perPage); i++) {
    pageNumbers.push(i)
  }
  const totalPages = pageNumbers.length;

  let display = current.length > 0 ? current.map((data, index) => {
    let id = data.id

    return (

<> 
<div className="row " key={data.id}
              
               onClick={() => {if(data.status!=="rejected") {navigate( `/hospital-details/${id}`)}}}
             style={{fontSize:"13px",  cursor: "pointer",textAlign: "left",borderLeft:"0.4px solid gray", borderBottom:"0.4px solid gray",borderRight:"0.4px solid gray",
              boxShadow:" 2px 2px 7px rgb(0 0 0 / 30%)",marginBottom:"0.5%"}}>
<div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}} className="col-1">{data.id}</div>
                        <div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}}className= {selected==="approved"?"col-2":"col-3"}>{}{data.name}</div>
                        {selected==="approved"&& <div style={{ padding:"1%"}}className="col-1">{data.patients_count}</div>}
                    <div style={{ padding:"1%"}} className="col-2">{data.category}</div>
                    <div style={{ padding:"1%"}}className="col-2">{data.health_care_type}</div>
                    
                    <div style={{ padding:"1%"}}className="col-2">{data.date_of_joining}</div>
                    <div style={{ padding:"1%"}} className="col-2" >{data.location}</div></div>
{/* <div
              className="care-features"
              >
              <div className="">
                <h5 className="feature-title " >
                  <b>
                    {" "}
                    <span className=""
                      style={{ cursor: "pointer"}}
                      onClick={() =>  {if(data.status!=="rejected") {navigate( `/hospital-details/${id}`)}}}
                    >
                     {(currentPage - 1) * 10 + index + 1}.{data.name}{" "}
                     
                    </span>
                    <small>ID : {data.id} </small>
                  </b>

                  
                </h5>
              </div>

             
            </div> */}



   </> )
  }) : null
  const handleBack = (e) => {
    navigate(-1);
  };
  return (
  
    <div className='row ' style={{marginTop:"1%",width:"100%",minHeight:"71vh"}}>


 
    <div className="col-3">
    <h4 className="" style={{color:"#55479F",paddingLeft:"2%"}}>CLINICS </h4>
       <div className="det-div " style={{padding:"1%"}}>
      
       
   <button className={selected==="pending"?"patientRecbutton1":"patientRecbutton"}
   style={{width:"100%",}}
     onClick={() => {
      setSelected("pending")
     }}
   >
     &nbsp;
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="currentColor" fillRule="evenodd" d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3h-8Zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V7Zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79V28Zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29H29Zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0Z" clipRule="evenodd" /></svg>
     &nbsp;
     Pending{" "}
   
   </button>
   <button className={selected==="approved"?"patientRecbutton1":"patientRecbutton"}
   style={{width:"100%"}}
     onClick={() => {
      setSelected("approved")
     }}
   >
     &nbsp;
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
     &nbsp;
     Approved{" "}
   
   </button>
   <button className={selected==="rejected"?"patientRecbutton1":"patientRecbutton"}
   style={{width:"100%",}}
     onClick={() => {
      setSelected("rejected")
     }}
   >
     &nbsp;
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
     &nbsp;
     Rejected{" "}
   
   </button>
   <button className={selected==="expired"?"patientRecbutton1":"patientRecbutton"}
   style={{width:"100%",}}
     onClick={() => {
      setSelected("expired");getExpClinics()
     }}
   >
     &nbsp;
     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
     &nbsp;
     Expired{" "}
   
   </button>
   
   </div>
       </div>
         
      
       
          <div className="col-9" style={{minHeight:"71vh"}}>
          <div className="">
         
              <div className="container"  style={{ }}>
                
             {selected!=="expired"&& <div className='row'>
            
             
        <div className="col-11">
        <div className="search-div row">
                <div className="col-3" >

                  <input

                    type="text"
                    className="search-clinics"
                    placeholder="Search clinic"
                    value={nameSearch}
                    onChange={(e) =>{ setCurrentPage(1);setNameSearch(e.target.value)}}
                    // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
                  />
                 

                </div>
                <div className="col-3" >

<input

  type="text"
  className="search-clinics"
  placeholder="Search ID"
  value={idSearch}
  onChange={(e) =>{ setCurrentPage(1);setIdSearch(e.target.value)}}
  // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
/>


</div>
<div className="col-3" >

<input

  type="text"
  className="search-clinics"
  placeholder="Search location"
  value={locSearch}
  onChange={(e) =>{ setCurrentPage(1);setLocSearch(e.target.value)}}
  // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
/>


</div>
<div className="col-3" >
<select
                        name='allergytype'
                        className="search-clinics"
                       
                        value={typeSearch}
                        onChange={(e) =>{ setCurrentPage(1);setTypeSearch(e.target.value)}}
                        >
                        <option value=""   >All</option>
                        <option value="ModernMedicine" >Modern Medicine</option>
                        <option value="Ayurveda" >Ayurveda</option>
                        <option value="Homeopathy" >Homeopathy</option>
                        <option value="Unani" >Unani</option>
                        <option value="Dental" >Dental</option>
                        <option value="Multispeciality" >Multispeciality</option>
                        <option value="Other" >Other</option>
                        
                    </select>



</div>
              </div>
        </div>
     
        <div className="col-1">
              <button className="" onClick={() =>{sort===""?setSort("asc"):setSort("")}} style={{ boxShadow: "3px 5px 10px rgba(0,0,0,0.2)", height: "40px", fontSize: "small",  color: "white", backgroundColor: "#272244", border: "none",borderRadius:"5px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z"/></svg>
              </button>
            </div>
            {/* <div className="col-2">
              <button className="" onClick={() => navigate("/Deregistered_splist")} style={{ boxShadow: "3px 5px 10px rgba(0,0,0,0.2)", height: "40px", fontSize: "small",  color: "white", backgroundColor: "#272244", border: "none",borderRadius:"5px" }}>
              Deregistered Clinics  <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div> */}
      </div>}
            </div><br/>

              <div className="" style={{margin:"auto"}}>
                <div className="container" style={{}}>
                  <div className="test-reports-display-list">
                    {display ? <>
                      <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left",padding:"1%", borderRadius:"5px 5px 0px 0px", boxShadow:" 2px 2px 7px rgb(0 0 0 / 30%)",marginBottom:"0.5%",fontSize:"12px"}}>
                      <div  className="col-1"><b>ID</b></div>
                    <div  className={selected==="approved"?"col-2":"col-3"}><b>Clinic</b></div>
                   {selected==="approved"&& <div className="col-1"><b >Patients</b></div>}
                    <div className="col-2"><b >Category</b></div>
                    <div className="col-2"><b >Type </b></div>
                   
                    <div className="col-2"><b >Date</b></div>
                    <div className="col-2"><b >Location</b></div>
                    
                    
                </div>
                      {display}
                      </> : (
                      <div style={{ color: "", fontSize: "20px", height: "200px", padding: "10%" }}>
                       {!loading? <h5>{selected==="approved"?"No more approved list to show!!":selected==="pending"?"No more pending list to show!!":selected==="rejected"?"No more rejected list to show!!":"No more expired list to show!!"}</h5>:""}
                      </div>
                    )}
                  </div>

                </div>
              </div>

              {totalPages > 1 ?
                <div className="pagn pagn-small">
                  <br />
                  <br />
                  <br />
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={perPage}
                    totalItemsCount={total}
                    pageRangeDisplayed={totalPages}
                    onChange={handlePageChange}
                    disabledClass="disabled-class"
                  />
                </div>
                : null}

            </div>
          </div>
        
      </div>
  )
}

export default RegisteredHospitals
